import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { IPage, IPageSize, ISearchValue, ISort, TDefaultStoreDTO } from '@interfaces/common/store';

import { defaultMeta } from '@enums/common';

interface IInitialState extends TDefaultStoreDTO {
	isActive: boolean | null;
	organisationType: string | null;
}

const initialState: IInitialState = {
	...defaultMeta,
	sortDirection: false,
	sortFieldName: null,
	searchValue: '',
	isActive: null,
	organisationType: null,
};

const organisations = createSlice({
	name: 'organisations',
	initialState,
	reducers: {
		setPage: (state, action: PayloadAction<IPage>) => {
			state.page = action.payload.page;
		},
		setPageSize: (state, action: PayloadAction<IPageSize>) => {
			state.pageSize = action.payload.pageSize;
			state.page = initialState.page;
		},
		setSort: (state, action: PayloadAction<ISort>) => {
			state.sortDirection = action.payload.sortDirection;
			state.sortFieldName = action.payload.sortFieldName;
		},
		setSearchValue: (state, action: PayloadAction<ISearchValue>) => {
			state.searchValue = action.payload.searchValue;
			state.page = initialState.page;
		},
		setIsActive: (state, action: PayloadAction<{ isActive: boolean | null }>) => {
			state.isActive = action.payload.isActive;
			state.page = initialState.page;
		},
		setOrganisationType: (state, action: PayloadAction<{ organisationType: string | null }>) => {
			state.organisationType = action.payload.organisationType;
			state.page = initialState.page;
		},
		resetOrganisationsTable: () => initialState,
	},
});

export const {
	setPage,
	setPageSize,
	setSort,
	setSearchValue,
	setIsActive,
	setOrganisationType,
	resetOrganisationsTable,
} = organisations.actions;

export default organisations.reducer;
